import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

export const Toast = ({ visible = false, onClose, msg = "메세지 없음", setFormData }) => {
    const [toastStatus, setToastStatus] = useState(visible);

    useEffect(() => {
        let timer;
        if (visible) {
            setToastStatus(true);
            timer = setTimeout(() => {
                setToastStatus(false);
                if (onClose) {
                    onClose();
                }
                if (setFormData) {
                    setFormData((prev) => ({
                        ...prev,
                        toastMsg: "",
                    }));
                }
            }, 2000);
        } else {
            setToastStatus(false);
        }
        return () => clearTimeout(timer);
    }, [visible, onClose, setFormData]);

    return ReactDOM.createPortal(
        <div className={`toast ${toastStatus ? "active" : ""}`}>
            <span>{msg}</span>
        </div>,
        document.body
    );
};
